import { TAGS } from "../constants";
import {
  BucketFile,
  BucketProps,
  FileStorage,
  UpdateFile,
  UploadFile,
} from "../types";
import { api } from "./api";

export const bucketApi = api.injectEndpoints({
  endpoints: (builder) => ({
    //storage bucket
    uploadFileToBucket: builder.mutation<void, UploadFile>({
      query: ({ file, bucket, path, title, uploadedBy }) => {
        const form = new FormData();
        form.append("file", file, file.name);
        form.append("bucket", bucket);
        form.append("path", path);
        form.append("title", title ?? "");
        form.append("uploadedBy", uploadedBy ?? "");

        return {
          method: "POST",
          url: "/api/bucket/upload/fitness-nutrition",
          body: form,
        };
      },
      invalidatesTags: [TAGS.FILE_STORAGE],
    }),
    getFiles: builder.query<
      { data: FileStorage[]; count: number },
      { status?: string }
    >({
      query: (params) => ({
        method: "GET",
        url: "/api/bucket/list-files",
        params,
      }),
      providesTags: [TAGS.FILE_STORAGE],
    }),
    downloadFile: builder.query<string, BucketProps>({
      query: (body) => ({
        method: "POST",
        url: "/api/bucket",
        responseHandler: "text",
        body,
      }),
      transformResponse: (res: string) => res,
    }),
    getSignedUrl: builder.query<string, { folder: string; path: string }>({
      query: ({ folder, path }) => ({
        method: "GET",
        url: `/api/bucket/${folder}`,
        responseHandler: "text",
        params: {
          path,
        },
      }),
    }),
    updateFile: builder.mutation<FileStorage, UpdateFile>({
      query: ({ id, ...rest }) => ({
        method: "PUT",
        url: `/api/bucket/file/${id}`,
        body: rest,
      }),
      invalidatesTags: [TAGS.FILE_STORAGE],
    }),
    uploadFile: builder.mutation<
      BucketFile,
      {
        file: File | Blob;
        bucket: string;
        path: string;
        name: string;
      }
    >({
      query: ({ bucket, file, path, name }) => {
        const form = new FormData();
        form.append("file", file, name);
        form.append("bucket", bucket);
        form.append("path", path);

        return { method: "POST", url: `/api/bucket/upload`, body: form };
      },
      invalidatesTags: [TAGS.BUCKET],
    }),
    getFilesByPaths: builder.query<
      { path: string; signedUrl: string }[],
      { bucket: string; paths: string[] }
    >({
      query: ({ bucket, paths }) => ({
        method: "POST",
        url: `/api/bucket/signed`,
        body: {
          bucket,
          paths,
        },
      }),
      providesTags: [TAGS.BUCKET],
    }),
  }),
});

export const {
  useGetFilesQuery,
  useUpdateFileMutation,
  useUploadFileToBucketMutation,
  useDownloadFileQuery,
  useUploadFileMutation,
  useGetSignedUrlQuery,
  useGetFilesByPathsQuery,
} = bucketApi;
